import React from "react";
import { Link } from "react-router-dom";

export default function DsBlock(props) {
    return (<div className='access__to__data'>
        {props.switcher ? <div>
            <p>
                Полный доступ к данным вашей компании:
            </p>
            <Link to='/registration'>
                <button className='access__to__data_btn' onClick={props.hanldeRegByDs}>
                    По электронной подписи
                </button>
            </Link>
        </div> : <Link to='/login'>
            <button className='access__to__data_btn' onClick={props.hanldeAuthByDs}>
                По электронной подписи
            </button>
        </Link>}

        <div className='docs__block'>
            <a target="_blank" href={props.instruction}>
                <div className='docs__text'>Инструкция по входу и регистрации через&nbsp;УКЭП&nbsp;ЮЛ / ИП</div>
            </a>
            <a href='https://www.cryptopro.ru/sites/default/files/products/cades/demopage/cades_bes_sample.html' target='_blank'>
                <div className='docs__text'>Проверить работу плагина КриптоПро</div>
            </a>
        </div>
    </div>);
}